import type { PartId } from '../../types';

type ProductStrings = {
    PRODUCT_BATTERY: string;
    PRODUCT_ESC: string;
    PRODUCT_FLOW_METER: string;
    PRODUCT_MOTOR: string;
    PRODUCT_NOZZLE_SET: string;
    PRODUCT_PROP_SET: string;
    PRODUCT_PUMP_SEAL_KIT: string;
    PRODUCT_RTK_ANTENNA: string;
};

export const getProductLabels = (strings: ProductStrings): Record<PartId, string> => ({
    battery: strings.PRODUCT_BATTERY,
    esc: strings.PRODUCT_ESC,
    flowMeter: strings.PRODUCT_FLOW_METER,
    motor: strings.PRODUCT_MOTOR,
    nozzleSet: strings.PRODUCT_NOZZLE_SET,
    propSet: strings.PRODUCT_PROP_SET,
    pumpSealKit: strings.PRODUCT_PUMP_SEAL_KIT,
    rtkAntenna: strings.PRODUCT_RTK_ANTENNA
});
